import {
  VOICE_UI_LANGUAGES,
  type VoiceUILanguage,
} from '../types/webclient-config.type';

export const LANGUAGE_OPTIONS = [
  { value: 'dutch', translationKey: 'voice-ai.languages.dutch' },
  { value: 'english', translationKey: 'voice-ai.languages.english' },
];

export const TONE_OPTIONS = [
  {
    value: 'friendly-professional',
    translationKey: 'voice-ai.tones.friendly-professional',
  },
  { value: 'professional', translationKey: 'voice-ai.tones.professional' },
  { value: 'friendly', translationKey: 'voice-ai.tones.friendly' },
  { value: 'playful', translationKey: 'voice-ai.tones.playful' },
  { value: 'humorous', translationKey: 'voice-ai.tones.humorous' },
];

export const getLanguageOptions = (t: (key: string) => string) =>
  LANGUAGE_OPTIONS.map((option) => ({
    value: option.value,
    description: t(option.translationKey),
  }));

const VOICE_UI_LANGUAGE_TRANSLATION_KEYS: Record<VoiceUILanguage, string> = {
  nl: 'voice-ai.languages.dutch',
  en: 'voice-ai.languages.english',
};

// * Shown only as the wrap-up input placeholder. The wrap-up signal is opt-in,
// * so nothing fills this value into a stored or served config.
export const SUGGESTED_VOICE_WRAP_UP_AT_SECONDS = 255;

// Options for the language of the Voice tab UI in the webclient widget.
export const getVoiceUILanguageOptions = (t: (key: string) => string) =>
  VOICE_UI_LANGUAGES.map((language) => ({
    value: language,
    description: t(VOICE_UI_LANGUAGE_TRANSLATION_KEYS[language]),
  }));

export const getToneOptions = (t: (key: string) => string) =>
  TONE_OPTIONS.map((option) => ({
    value: option.value,
    description: t(option.translationKey),
  }));

export const getToneLabel = (
  tone: string,
  t: (key: string) => string,
): string => {
  const option = TONE_OPTIONS.find((option) => option.value === tone);
  return option ? t(option.translationKey) : tone;
};

export const getLanguageLabel = (
  language: string,
  t: (key: string) => string,
): string => {
  const option = LANGUAGE_OPTIONS.find((option) => option.value === language);
  return option ? t(option.translationKey) : language;
};
